module.exports = __webpack_public_path__ + "portal-static/img/code7.d56d2614.png";